export enum FirebaseErrorCode {
    emailAlreadyInUse = "auth/email-already-in-use",
    weakPassword = "auth/weak-password",
    manyRequests = "auth/too-many-requests",
    tooManyAttempts = "auth/too-many-attempts",
    invalidCredential = "auth/invalid-credential",
    wrongPassword = "auth/wrong-password",
    userNotFound = "auth/user-not-found",
    invalidEmail = "auth/invalid-email",
    invalidInvite = "auth/invalid-invite",
    forbiddenInvite = "auth/forbidden-invite",
    inappropriateInvite = "aith/inappropriate-invite",
    accessPermissions = "auth/access-permissions",
    invalidProvider = "auth/account-exists-with-different-credential",
    cancelPopup = "auth/cancelled-popup-request",
    closePopup = "auth/popup-closed-by-user",
    verificationEmailFailed = "auth/verification-email-failed",
    /** Tenant policy (tenant_authentication_plan.md §2.6): Microsoft account from an unlisted directory. */
    directoryNotAllowed = "auth/directory-not-allowed",
    /** Tenant policy: email outside the allowed domains. */
    domainNotAllowed = "auth/domain-not-allowed",
    /** Firebase tenant password policy (Phase 3): the password breaks a rule. */
    passwordPolicy = "auth/password-does-not-meet-requirements",
    /** Tenant policy: the password is past the tenant's expiry window. */
    passwordExpired = "auth/password-expired",
    /** Tenant policy: the sign-in method used is switched off for this tenant. */
    methodNotAllowed = "auth/method-not-allowed",
    /** Main-app SSO (Phase 4): the IdP's email already exists as a password account; link it. */
    ssoLinkRequired = "auth/sso-link-required"
}
